const REG_EX = /<[^<>]+>/gm;

const parseTemplate = (value: string): string[] => {
  return value.match(REG_EX) || [];
};

export { parseTemplate };
